import React from 'react'

function Sales() {
  return (
    <div>Sales</div>
  )
}

export default Sales